// Recovered compiled webpack factory 9766. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return j;
      },
    }));
  let n = r(28140),
    a = r(49417),
    o = r(95155),
    i = r(86871),
    s = a._(r(12115)),
    l = n._(r(47650)),
    u = r(46752),
    c = r(32753),
    f = r(48359),
    d = r(88785),
    p = r(7460),
    h = r(84170),
    _ = r(10531),
    m = r(63886),
    g = r(69190),
    y = r(48915),
    v = r(76248),
    b = r(39684);
  r(74061);
  let E = l.default.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    R = ["bottom", "height", "left", "right", "top", "width", "x", "y"];
  function P(e, t) {
    let r = e.getBoundingClientRect();
    return r.top >= 0 && r.top <= t;
  }
  class S extends s.default.Component {
    componentDidMount() {
      this.handlePotentialScroll();
    }
    componentDidUpdate() {
      this.props.focusAndScrollRef.apply && this.handlePotentialScroll();
    }
    render() {
      return this.props.children;
    }
    constructor(...e) {
      (super(...e),
        (this.handlePotentialScroll = () => {
          let { focusAndScrollRef: e, segmentPath: t } = this.props;
          if (e.apply) {
            if (
              0 !== e.segmentPaths.length &&
              !e.segmentPaths.some((e) => t.every((t, r) => (0, p.matchSegment)(t, e[r])))
            )
              return;
            let r = null,
              n = e.hashFragment;
            if (
              (n &&
                (r = (function (e) {
                  var t;
                  return "top" === e
                    ? document.body
                    : null != (t = document.getElementById(e))
                      ? t
                      : document.getElementsByName(e)[0];
                })(n)),
              r || (r = (0, E.findDOMNode)(this)),
              !(r instanceof Element))
            )
              return;
            for (
              ;
              !(r instanceof HTMLElement) ||
              (function (e) {
                if (["sticky", "fixed"].includes(getComputedStyle(e).position)) return !0;
                let t = e.getBoundingClientRect();
                return R.every((e) => 0 === t[e]);
              })(r);

            ) {
              if (null === r.nextElementSibling) return;
              r = r.nextElementSibling;
            }
            ((e.apply = !1),
              (e.hashFragment = null),
              (e.segmentPaths = []),
              (0, h.disableSmoothScrollDuringRouteTransition)(
                () => {
                  if (n) return void r.scrollIntoView();
                  let e = document.documentElement,
                    t = e.clientHeight;
                  !P(r, t) && ((e.scrollTop = 0), P(r, t) || r.scrollIntoView());
                },
                { dontForceLayout: !0, onlyHashChange: e.onlyHashChange },
              ),
              (e.onlyHashChange = !1),
              r.focus());
          }
        }));
    }
  }
  function O(e) {
    let { segmentPath: t, children: r } = e,
      n = (0, s.useContext)(u.GlobalLayoutRouterContext);
    if (!n)
      throw Object.defineProperty(
        Error("invariant global layout router not mounted"),
        "__NEXT_ERROR_CODE",
        { value: "E473", enumerable: !1, configurable: !0 },
      );
    return (0, o.jsx)(S, { segmentPath: t, focusAndScrollRef: n.focusAndScrollRef, children: r });
  }
  function T(e) {
    let { tree: t, segmentPath: r, cacheNode: n, url: a } = e,
      l = (0, s.useContext)(u.GlobalLayoutRouterContext);
    if (!l)
      throw Object.defineProperty(
        Error("invariant global layout router not mounted"),
        "__NEXT_ERROR_CODE",
        { value: "E473", enumerable: !1, configurable: !0 },
      );
    let { tree: d } = l,
      h = null !== n.prefetchRsc ? n.prefetchRsc : n.rsc,
      _ = (0, s.useDeferredValue)(n.rsc, h),
      m = "object" == typeof _ && null !== _ && "function" == typeof _.then ? (0, s.use)(_) : _;
    if (!m) {
      let e = n.lazyData;
      if (null === e) {
        let t = (function e(t, r) {
            if (t) {
              let [n, a] = t,
                o = 2 === t.length;
              if ((0, p.matchSegment)(r[0], n) && r[1].hasOwnProperty(a)) {
                if (o) {
                  let t = e(void 0, r[1][a]);
                  return [r[0], { ...r[1], [a]: [t[0], t[1], t[2], "refetch"] }];
                }
                return [r[0], { ...r[1], [a]: e(t.slice(2), r[1][a]) }];
              }
            }
            return r;
          })(["", ...r], d),
          o = (0, y.hasInterceptionRouteInCurrentTree)(d),
          u = Date.now();
        ((n.lazyData = e =
          (0, c.fetchServerResponse)(new URL(a, location.origin), {
            flightRouterState: t,
            nextUrl: o ? l.nextUrl : null,
          }).then(
            (e) => (
              (0, s.startTransition)(() => {
                (0, v.dispatchAppRouterAction)({
                  type: i.ACTION_SERVER_PATCH,
                  previousTree: d,
                  serverResponse: e,
                  navigatedAt: u,
                });
              }),
              e
            ),
          )),
          (0, s.use)(e));
      }
      (0, s.use)(f.unresolvedThenable);
    }
    return (0, o.jsx)(u.LayoutRouterContext.Provider, {
      value: { parentTree: t, parentCacheNode: n, parentSegmentPath: r, url: a },
      children: m,
    });
  }
  function w(e) {
    let t,
      { loading: r, children: n } = e;
    if (
      (t = "object" == typeof r && null !== r && "function" == typeof r.then ? (0, s.use)(r) : r)
    ) {
      let e = t[0],
        r = t[1],
        a = t[2];
      return (0, o.jsx)(s.Suspense, {
        fallback: (0, o.jsxs)(o.Fragment, { children: [r, a, e] }),
        children: n,
      });
    }
    return (0, o.jsx)(o.Fragment, { children: n });
  }
  function j(e) {
    let {
        parallelRouterKey: t,
        error: r,
        errorStyles: n,
        errorScripts: a,
        templateStyles: i,
        templateScripts: l,
        template: c,
        notFound: f,
        forbidden: p,
        unauthorized: h,
        segmentViewBoundaries: y,
      } = e,
      v = (0, s.useContext)(u.LayoutRouterContext);
    if (!v)
      throw Object.defineProperty(
        Error("invariant expected layout router to be mounted"),
        "__NEXT_ERROR_CODE",
        { value: "E56", enumerable: !1, configurable: !0 },
      );
    let { parentTree: E, parentCacheNode: R, parentSegmentPath: P, url: S } = v,
      j = R.parallelRoutes,
      x = j.get(t);
    x || ((x = new Map()), j.set(t, x));
    let A = E[0],
      C = null === P ? [t] : P.concat([A, t]),
      M = E[1][t],
      N = M[0],
      k = (0, g.createRouterCacheKey)(N, !0),
      I = (0, b.useRouterBFCache)(M, k),
      L = [];
    do {
      let e = I.tree,
        t = I.stateKey,
        s = e[0],
        y = (0, g.createRouterCacheKey)(s),
        v = x.get(y);
      if (void 0 === v) {
        let e = {
          lazyData: null,
          rsc: null,
          prefetchRsc: null,
          head: null,
          prefetchHead: null,
          parallelRoutes: new Map(),
          loading: null,
          navigatedAt: -1,
        };
        ((v = e), x.set(y, e));
      }
      let b = R.loading,
        E = (0, o.jsxs)(
          u.TemplateContext.Provider,
          {
            value: (0, o.jsxs)(O, {
              segmentPath: C,
              children: [
                (0, o.jsx)(d.ErrorBoundary, {
                  errorComponent: r,
                  errorStyles: n,
                  errorScripts: a,
                  children: (0, o.jsx)(w, {
                    loading: b,
                    children: (0, o.jsx)(m.HTTPAccessFallbackBoundary, {
                      notFound: f,
                      forbidden: p,
                      unauthorized: h,
                      children: (0, o.jsxs)(_.RedirectBoundary, {
                        children: [
                          (0, o.jsx)(T, { url: S, tree: e, cacheNode: v, segmentPath: C }),
                          null,
                        ],
                      }),
                    }),
                  }),
                }),
                null,
              ],
            }),
            children: [i, l, c],
          },
          t,
        );
      (L.push(E), (I = I.next));
    } while (null !== I);
    return L;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
